import common from '../modules/common/locales/en-US';
import log from "../modules/log/locales/en-US";
import dict from "../modules/dict/locales/en-US";
import account from '../modules/account/locales/en-US';
import workflow from '../modules/workflow/locales/en-US';
import mail from "../modules/mail/locales/en-US";
import wechat from "../modules/wechat/locales/en-US";
import vms from "../modules/vms/locales/en-US";
import exos from "../modules/exos/locales/en-US";

const en_US = {
    ...common,
    ...log,
    ...dict,
    ...account,
    ...workflow,
    ...mail,
    ...wechat,
    ...vms,
    ...exos
}

export default en_US;